import { GenericResult } from 'components';
import { useTranslation } from 'react-i18next';
import successIcon from 'assets/images/liHome/changepwd-success.svg';
import styled from 'styled-components';
import GreetingSection from 'components/navbar/GreetingSection';

import { Grid, Typography } from 'antd';

const { useBreakpoint } = Grid;
const ChangeSuccess = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  @media (max-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const LifeChangePwdSuccess = () => {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();

  return (
    <ChangeSuccess>
      {lg && (
        <Typography.Title
          level={3}
          style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#20252B', fontWeight: '400', marginTop: '40px' }}
        >
          {t('life.changePassword.title')}
        </Typography.Title>
      )}
      {!lg && <GreetingSection pageName={t('life.changePassword.title')} showicon={false} />}
      <GenericResult
        icon={<img src={successIcon} />}
        title={t('life.changePassword.successTitle')}
        defaultTo="/LifeAccount"
        defaultLabel={t('life.changePassword.done')}
        style={{ backgroundColor: '#fff' }}
      />
    </ChangeSuccess>
  );
};
